/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ZipFolder72Icon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 72, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="ZipFolder72Icon"
          width="72"
          height="72"
          viewBox="0 0 72 72"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M30.5928 17.0088C31.1352 17.0512 31.6574 17.2407 32.1025 17.5586L38.0596 21.8135C38.2291 21.9346 38.4323 21.9999 38.6406 22H55C56.6569 22 58 23.3431 58 25V52C58 53.6569 56.6569 55 55 55H17C15.3431 55 14 53.6569 14 52V20C14 18.3431 15.3431 17 17 17H30.3594L30.5928 17.0088ZM16 52C16 52.5523 16.4477 53 17 53H55C55.5523 53 56 52.5523 56 52V31H32.4141L29 34.4141V35H30.5C30.7761 35 31 35.2239 31 35.5C31 35.7761 30.7761 36 30.5 36H29V37H30.5C30.7761 37 31 37.2239 31 37.5C31 37.7761 30.7761 38 30.5 38H29V39H30.5C30.7761 39 31 39.2239 31 39.5C31 39.7761 30.7761 40 30.5 40H29V41H29.5C30.3284 41 31 41.6716 31 42.5V44.5C31 45.3284 30.3284 46 29.5 46H26.5C25.6716 46 25 45.3284 25 44.5V42.5C25 41.6716 25.6716 41 26.5 41H27V40H25.5C25.2239 40 25 39.7761 25 39.5C25 39.2239 25.2239 39 25.5 39H27V38H25.5C25.2239 38 25 37.7761 25 37.5C25 37.2239 25.2239 37 25.5 37H27V36H25.5C25.2239 36 25 35.7761 25 35.5C25 35.2239 25.2239 35 25.5 35H27V34.4141L23.5859 31H16V52ZM26.5 42C26.2239 42 26 42.2239 26 42.5V44.5C26 44.7761 26.2239 45 26.5 45H29.5C29.7761 45 30 44.7761 30 44.5V42.5C30 42.2239 29.7761 42 29.5 42H26.5ZM17 19C16.4477 19 16 19.4477 16 20V29H23.5859C24.1163 29 24.625 29.2109 25 29.5859L28 32.5859L31 29.5859C31.375 29.2109 31.8837 29 32.4141 29H56V25C56 24.4477 55.5523 24 55 24H38.6406C38.0156 23.9999 37.4061 23.8047 36.8975 23.4414L30.9404 19.1865C30.8131 19.0956 30.6668 19.0357 30.5137 19.0117L30.3594 19H17Z"
              fill="currentColor"
            />
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

ZipFolder72Icon.tags = ['zip', 'folder', 'compress', 'archive', 'storage'];

ZipFolder72Icon.category = '72x72 (File types)';

ZipFolder72Icon.iconSize = 72;
